<template>
  <div class="widget agent-list" ref="board">
    <div class="widget-title">
      <!-- <v-icon>{{ getIconByShift(settings.value.selected_shift) }}</v-icon> -->
      <!-- {{ getShiftName(settings.value.selected_shift) }} -->
      {{ title('Agent List') }}
    </div>
    <div class="widget-content">
      <div
        class="entity-item agent-item item"
        v-for="(user, i) in filteredAgents"
        :class="{
          [setColor(user, i)]: true
        }"
        :ref="!filteredAgents[i + 1] ? 'last-item' : ''"
        :key="user.id"
      >
        <!-- Agent -->
        <div class="position">{{ i + 1 }}</div>

        <div class="item-label">
          <div class="agent-avatar-block">
            <img class="agent-avatar" :src="getAvatar(user)">
          </div>
          <p class="name">{{ user.full_name }}</p>
        </div>

        <div class="item-data">
          <!-- progress -->
          <v-progress-linear
            v-if="settings.value.show_sales_progress_bar"
            color="#5ce7ff"
            background-color="#fff"
            height="8"
            :value="getValueProgress(user)"
          ></v-progress-linear>
          <!-- progress -->

          <!-- daily -->
          <div class="col" v-if="settings.value.show_daily">
            <div class="type">
              <div class="frow">
                <v-icon>{{ getColor(user[useByPaymentCapacity('daily')]) === "pos" ? "fa-caret-up" : "fa-caret-down" }}</v-icon>
                <span
                  :class="{
                    'green-c': getColor(user[useByPaymentCapacity('daily')]) === 'pos',
                    'red-c': getColor(user[useByPaymentCapacity('daily')]) === 'neg',
                  }"
                >
                  Daily:
                </span>
              </div>
              <strong>
                <template v-if="target_type === 'Amount'">
                  {{ user[useByPaymentCapacity('daily')][useNetAmount()] | numFormat(currency) }}
                </template>
                <template v-else>
                  {{ user[useByPaymentCapacity('daily')][useNetCount] | numFormat }}
                </template>
              </strong>
              <span class="word-sales" v-if="!currency">Sales</span>
            </div>
            <div class="targ" v-if="settings.value.show_daily_target">
              <div class="frow">
                <v-icon>fa-caret-up</v-icon>
                <span class="green-c"> Target: </span>
              </div>
              <strong>{{ user[useByPaymentCapacity('daily')]["goal"] | numFormat(currency) }} </strong>
              <span class="word-sales" v-if="!currency">Sales</span>
            </div>
          </div>
          <!-- daily -->

          <!-- weekly -->
          <div class="col" v-if="settings.value.show_weekly">
            <div class="type">
              <div class="frow">
                <v-icon>{{ getColor(user[useByPaymentCapacity('weekly')]) === "pos" ? "fa-caret-up" : "fa-caret-down" }}</v-icon>
                <span
                  :class="{
                    'green-c': getColor(user[useByPaymentCapacity('weekly')]) === 'pos',
                    'red-c': getColor(user[useByPaymentCapacity('weekly')]) === 'neg',
                  }"
                >
                  Weekly:
                </span>
              </div>
              <strong>
                <template v-if="target_type === 'Amount'">
                {{ user[useByPaymentCapacity('weekly')][useNetAmount()] | numFormat(currency) }}
                </template>
                <template v-else>
                  {{ user[useByPaymentCapacity('weekly')][useNetCount] | numFormat }}
                </template>
              </strong>
              <span class="word-sales" v-if="!currency">Sales</span>
            </div>
            <div class="targ" v-if="settings.value.show_weekly_target">
              <v-icon>fa-caret-up</v-icon>
              <span class="green-c"> Target: </span>
              <strong>{{ user[useByPaymentCapacity('weekly')]["goal"] | numFormat(currency) }} </strong>
              <span class="word-sales" v-if="!currency">Sales</span>
            </div>
          </div>
          <!-- weekly -->

          <!-- monthly -->
          <div class="col" v-if="settings.value.show_monthly">
            <div class="type">
              <v-icon>{{ getColor(user[useByPaymentCapacity('monthly')]) === "pos" ? "fa-caret-up" : "fa-caret-down" }}</v-icon>
              <span
                :class="{
                  'green-c': getColor(user[useByPaymentCapacity('monthly')]) === 'pos',
                  'red-c': getColor(user[useByPaymentCapacity('monthly')]) === 'neg',
                }"
              >
                Monthly:
              </span>
              <strong>
                <template v-if="target_type === 'Amount'">
                {{ user[useByPaymentCapacity('monthly')][useNetAmount()] | numFormat(currency) }}
                </template>
                <template v-else>
                  {{ user[useByPaymentCapacity('monthly')][useNetCount] | numFormat }}
                </template>
              </strong>
              <span class="word-sales" v-if="!currency">Sales</span>
            </div>
            <div class="targ" v-if="settings.value.show_monthly_target">
              <v-icon>fa-caret-up</v-icon>
              <span class="green-c"> Target: </span>
              <strong>{{ user[useByPaymentCapacity('monthly')]["goal"] | numFormat(currency) }} </strong>
              <span class="word-sales" v-if="!currency">Sales</span>
            </div>
          </div>
          <!-- monthly -->
        </div>

        <!-- Agent -->
      </div>
    </div>
  </div>
</template>


<script>
/* eslint-disable no-unused-vars */
import { mapGetters } from "vuex";
import { get, orderBy, fill } from "lodash";
import widgetHelper from "@/mixins/widgetHelper";
// import SendCongratulation from "@/mixins/send_congratulation";

const START_AMOUNT = 2000;
const START_COUNT = 5;
const COEFFICIENT_HIGH = 0.8;
const COEFFICIENT_LOW = 0.2;

export default {
  name: "AgentList",
  mixins: [widgetHelper],
  computed: {
    ...mapGetters(["streams"]),
    filteredAgents() {
      const agents = this.selectedAgents;

      const filters = [];

      const isAmount = this.settings.value.target_type !== 'Count';
      let saleFiled = isAmount ? 'gross_sale' : 'count';
      
      if (this.settings.value.use_net_amount) {
        saleFiled = isAmount ? 'net_sale' : 'net_count';
      }

      if (this.settings.value.show_monthly) {
        filters.push((product) =>  get(product, [this.useByPaymentCapacity("monthly"), saleFiled], 0))
      }
      else if (this.settings.value.show_weekly) {
        filters.push((product) => get(product, [this.useByPaymentCapacity("weekly"), saleFiled], 0))
      }
      else if (this.settings.value.show_daily) {
        filters.push((product) => get(product, [this.useByPaymentCapacity("daily"), saleFiled], 0))
      }

      const sort = new Array(filters.length).fill("desc");

      const agentsFiltered = orderBy(agents, filters, sort).slice(
        0,
        this.settings.value.max_agent_in_list
      );

      this.$emit('updateFilteredAgents', agentsFiltered.map(a => a.crm_id));
      return agentsFiltered;
    },

    margin() {
      const { board } = this.$refs;
      if (
        board &&
        this.$variables.appHeight > 0 &&
        this.$variables.appWidth > 0
      ) {
        return (
          board.offsetParent.offsetParent.offsetHeight <
          board.offsetParent.scrollHeight
        );
      }
      return false;
    },

    listeningAgents() {
      return this.filteredAgents.map(user => user.id) || [];
    }
  },
  data() {
    return {
      users: []
    };
  },
  methods: {
    getColor(obj) {
      if (
        (this.settings.value.use_net_amount ? obj.net_sale : obj.gross_sale) <
        obj.goal
      ) {
        return "neg";
      }
      return "pos";
    },

    setColor(user, index) {
        if (!user || !user.monthly) return '';

        if (this.settings.value.use_goal_colors) {
            const start_amount = this.settings.value.target_type === 'Amount' ? START_AMOUNT : START_COUNT;
            const target_type = this.settings.value.target_type === 'Amount' ? 'net_sale' : 'net_count';
            const monthly_type = this.useByPaymentCapacity('monthly');
            const current_amount = user[monthly_type][target_type];

            if (current_amount >= start_amount) {
                const daily_goal = user[monthly_type].goal / user[monthly_type].days.working;
                const goalPast = daily_goal * (user[monthly_type].days.working - user[monthly_type].days.remaining + 1);

                const high = goalPast * COEFFICIENT_HIGH;
                const middle = goalPast * COEFFICIENT_LOW;

                if(current_amount >= high){
                  return '_green';
                }
                else if (current_amount >= middle && current_amount < high ) {
                    return '_amber'
                }
                else {
                    return '_red'
                }
            }
        } else{
          if (this.settings.value.show_prize_places) {
            if (index === 0) {
                return '_gold _first';
            }
            else if (index === 1){
                return '_silver';
            }
            else if (index === 2){
                return '_bronze';
            }
          }
        }

        return '';
    },

    getValueProgress(user) {
      if (this.settings.value.show_monthly_target) {
        const percent = this.settings.value.use_net_amount
          ? user[this.useByPaymentCapacity('monthly')].net_sale
          : user[this.useByPaymentCapacity('monthly')].gross_sale;

        let num = (percent * 100) / user[this.useByPaymentCapacity('monthly')].goal;

        return num;
      } else if (this.settings.value.show_weekly_target) {
        const percent = this.settings.value.use_net_amount
          ? user[this.useByPaymentCapacity('weekly')].net_sale
          : user[this.useByPaymentCapacity('weekly')].gross_sale;

        let num = (percent * 100) / user[this.useByPaymentCapacity('weekly')].goal;
        return num;
      } else if (this.settings.value.show_daily_target) {
        const percent = this.settings.value.use_net_amount
          ? user[this.useByPaymentCapacity('daily')].net_sale
          : user[this.useByPaymentCapacity('daily')].gross_sale;

        let num = (percent * 100) / user[this.useByPaymentCapacity('daily')].goal;

        return num;
      }
    },

    getAvatar(user) {
      if (this.settings.value.use_user_logo_avatar && user.logo_avatar) {
          return user.logo_avatar || '';
      } else {
        let baseUrl = "https://d1ac9zce9817ms.cloudfront.net/images/icons";

        let number = parseInt(
          String(
            String(user.crm_id)
              .split("")
              .map((s) => s.charCodeAt(0))
              .reduce((a, b) => a + b, 0) % 15
          ),
          10
        );

        return baseUrl + String(number) + ".svg";
      }
    },
  },
};
</script>


<style lang="scss">
.agent-list {
  width: 100%;

  &.item-cols-3,
  &.item-cols-4 {
    .agent-avatar {
      width: 40px;
      height: 40px;
    }
    .agent-avatar-block {
      min-width: 45px;
      &:after {
        top: -16px !important;
        left: -5px !important;
        width: 33px !important;
        height: 22px !important;
      }
    }
    .item-label {
      padding-right: 5px;
    }
  }
}
.agent-item {
  &._green {
    background: rgba(0, 128, 0, 0.5);
  }
  &._amber {
    background: rgba(255, 191, 0, 0.5);
  }
  &._red {
    background: rgba(255, 0, 0, 0.5);
  }

  .word-sales {
    font-size: 14px;
    margin-top: 8px;
    font-weight: 600;
  }

  .item-data {
    padding-top: 24px;
    height: 100%;
    align-items: center;
  }

  &._first {
    position: relative;

    .agent-avatar-block {
      position: relative;

      &:after {
        content: "";
        position: absolute;
        top: -16px;
        left: 0px;
        z-index: 99;
        width: 40px;
        height: 25px;
        transform: rotate(-20deg);
        background-image: url(https://gallery.yopriceville.com/var/resizes/Free-Clipart-Pictures/Crowns-PNG/Gold_Crown_with_Diamond_PNG_Clip_Art_Image.png);
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
  }

  .item-label {
    padding: 18px 10px 10px 0;
  }
}

.agent-avatar-block {
  min-width: 60px;
  flex-shrink: 0;
}

.agent-avatar {
  max-width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #dedede;
  border: 1px solid #adff2f;
  width: 100%;
  object-fit: cover;
  object-position: 50%;
}
</style>
